'use strict';

module.exports = 'Boolean Number String Date RegExp Function Array Error Set Map';


//////////////////
// WEBPACK FOOTER
// ./~/sugar/common/var/NATIVE_TYPES.js
// module id = 265
// module chunks = 0